import VI_Lang from "@assets/images/Languages/vietnam.png";
import EN_Lang from "@assets/images/Languages/english.png";
import KO_Lang from "@assets/images/Languages/korea.png";
import JA_Lang from "@assets/images/Languages/japan.png";
import ZH_Lang from "@assets/images/Languages/china.png";
import KM_Lang from "@assets/images/Languages/campuchia.png";
import HI_Lang from "@assets/images/Languages/india.png";
import DE_Lang from "@assets/images/Languages/germany.png";
import FR_Lang from "@assets/images/Languages/france.png";
import PT_Lang from "@assets/images/Languages/portuga.png";
import ES_Lang from "@assets/images/Languages/spain.png";
import IT_Lang from "@assets/images/Languages/italy.png";
import AR_Lang from "@assets/images/Languages/arab.png";
import RU_Lang from "@assets/images/Languages/russia.png";
import AF_Lang from "@assets/images/Languages/english.png";
import BN_Lang from "@assets/images/Languages/india.png";
import ZH_TW_Lang from "@assets/images/Languages/china.png";
import TL_Lang from "@assets/images/Languages/english.png";
import HA_Lang from "@assets/images/Languages/english.png";
import ID_Lang from "@assets/images/Languages/vietnam.png";
import MS_Lang from "@assets/images/Languages/vietnam.png";
import MM_Lang from "@assets/images/Languages/vietnam.png";
import SW_Lang from "@assets/images/Languages/english.png";
import TH_Lang from "@assets/images/Languages/vietnam.png";
import TR_Lang from "@assets/images/Languages/germany.png";
import UR_Lang from "@assets/images/Languages/india.png";
import LO_Lang from "@assets/images/Languages/vietnam.png";
export const MEDIA_IMAGE_URL = "/media/api/files/view";

export const USER = 'user';
export const AUTHOR = 'author';
export const EDITOR = 'editor';
export const ADMIN = 'administrator';
export const SYSADMIN = 'sysAdmin';

export const PERMISSION = {
  LOGIN: [SYSADMIN, ADMIN, EDITOR, AUTHOR],
  DELETE: [SYSADMIN, ADMIN, AUTHOR],
  ADD_ADMIN: [SYSADMIN, ADMIN, AUTHOR],
  ADD_POST: [SYSADMIN, ADMIN, AUTHOR],
  DELETE_DOCUMENT: [SYSADMIN, ADMIN, AUTHOR],
  ACCESS_DEEP: [SYSADMIN, ADMIN],
}
export const LANGUAGE = [
  {
  key: 'vi',
  image: VI_Lang,
  title: "Vietnamese"
  },
  {
  key: 'en',
  image: EN_Lang,
  title: "English"
  },
  {
  key: 'af',
  image: AF_Lang,
  title: "Afrikaans"
  },
  {
  key: 'ar',
  image: AR_Lang,
  title: "Arabic"
  },
  {
  key: 'bn',
  image: BN_Lang,
  title: "Bengali"
  },
  {
  key: 'zh',
  image: ZH_Lang,
  title: "Chinese Simplified"
  },
  {
  key: 'zh-TW',
  image: ZH_TW_Lang,
  title: "Chinese Traditional"
  },
  {
  key: 'tl',
  image: TL_Lang,
  title: "Filipino"
  },
  {
  key: 'fr',
  image: FR_Lang,
  title: "French"
  },
  {
  key: 'de',
  image: DE_Lang,
  title: "German"
  },
  {
  key: 'ha',
  image: HA_Lang,
  title: "Hausa"
  },
  {
  key: 'hi',
  image: HI_Lang,
  title: "Hindi"
  },
  {
  key: 'id',
  image: ID_Lang,
  title: "Indonesian"
  },
  {
  key: 'it',
  image: IT_Lang,
  title: "Italian"
  },
  {
  key: 'ja',
  image: JA_Lang,
  title: "Japanese"
  },
  {
  key: 'km',
  image: KM_Lang,
  title: "Khmer"
  },
  {
  key: 'ko',
  image: KO_Lang,
  title: "Korean"
  },
  {
  key: 'lo',
  image: LO_Lang,
  title: "Lao"
  },
  {
  key: 'ms',
  image: MS_Lang,
  title: "Malay"
  },
  {
  key: 'mm',
  image: MM_Lang,
  title: "Myanmar"
  },
  {
  key: 'pt',
  image: PT_Lang,
  title: "Portuguese"
  },
  {
  key: 'ru',
  image: RU_Lang,
  title: "Russian"
  },
  {
  key: 'es',
  image: ES_Lang,
  title: "Spanish"
  },
  {
  key: 'sw',
  image: SW_Lang,
  title: "Swahili"
  },
  {
  key: 'th',
  image: TH_Lang,
  title: "Thai"
  },
  {
  key: 'tr',
  image: TR_Lang,
  title: "Turkish"
  },
  {
  key: 'ur',
  image: UR_Lang,
  title: "Urdu"
  }
  ];
export const PERMISSION_KEY = {
  ADD_ADMIN: 'ADD_ADMIN',
  ADD_POST: 'ADD_POST',
  DELETE_DOCUMENT: 'DELETE_DOCUMENT',
  ACCESS_DEEP: 'ACCESS_DEEP'
}
export const USD = 23000 // change usd to vnd
export const IDENTITY_SERVICE = process.env.REACT_APP_IDENTITY_SERVICE as string
export const CDN = process.env.REACT_APP_MEDIA_SERVICE as string
export const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_APP_ID as string
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID as string
export const GOOGLE_REDIRECT_URL = process.env.REACT_APP_GOOGLE_REDIRECT_URL as string
export const GOOGLE_SCOPES = process.env.REACT_APP_GOOGLE_SCOPES as string
export const API_GATEWAY = process.env.REACT_APP_API_GATEWAY as string
export const LOGO = process.env.REACT_APP_LOGO as string || '/logos/logo.png'
export const APP_NAME = process.env.REACT_APP_APP_NAME as string
export const THEME_COLOR = process.env.REACT_APP_THEME_COLOR as string
